import { DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchFreshReports } from 'utils/api/freshReportApi'
import { columns, FILTER_FIELD_FRESH_REPORT } from './utils'

type Props = {
  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const FreshReportDataTable = ({ loading, setLoading }: Props) => {
  const [response, setResponse] = useState<any>({})

  const { search } = useLocation()
  const { getAllQueries } = useQuery()

  const getReports = async () => {
    const queries = getAllQueries()
    const filters = queries[FILTER_FIELD_FRESH_REPORT]

    // A store is required by the API, so there is nothing to fetch until one
    // is chosen. Showing an empty table beats a 400 the user cannot act on.
    if (!filters?.store) {
      setResponse({ docs: [] })
      return
    }

    setLoading(true)

    try {
      const { data } = await fetchFreshReports({
        limit: queries.limit || 10,
        page: queries.page || 1,
        filters,
      })
      setResponse({ ...data })
    } catch {
      setResponse({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getReports()
  }, [search])

  return (
    <>
      <DataTable
        columns={columns}
        rows={loading ? null : response?.docs}
        identifier="_id"
      />

      <DataTablePagination
        currentPage={response?.page}
        totalPages={response?.totalPages}
        hasNextPage={response?.hasNextPage}
        hasPrevPage={response?.hasPrevPage}
        limit={response?.limit}
        nextPage={response?.nextPage}
        prevPage={response?.prevPage}
      />
    </>
  )
}

export default FreshReportDataTable
